import { render, staticRenderFns } from "./Contextmenu.vue?vue&type=template&id=c63a6fc2&scoped=true&"
import script from "./Contextmenu.vue?vue&type=script&lang=js&"
export * from "./Contextmenu.vue?vue&type=script&lang=js&"
import style0 from "./Contextmenu.vue?vue&type=style&index=0&id=c63a6fc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63a6fc2",
  null
  
)

export default component.exports